import { render, staticRenderFns } from "./setupAccount.vue?vue&type=template&id=3e2a2170&scoped=true"
import script from "./setupAccount.vue?vue&type=script&lang=js"
export * from "./setupAccount.vue?vue&type=script&lang=js"
import style0 from "./setupAccount.vue?vue&type=style&index=0&id=3e2a2170&prod&lang=scss&scoped=true"
import style1 from "./setupAccount.vue?vue&type=style&index=1&id=3e2a2170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a2170",
  null
  
)

export default component.exports